// Apple-Music-style lyrics view: the active line is sharp and centered,
// surrounding lines dim and blur, and the track glides smoothly between them.
import React, { useEffect, useLayoutEffect, useRef } from "react";

export interface DisplayLine {
  id: string;
  who: string;
  text: string;
  kind: "past" | "active" | "partial";
}

export function LyricsTranscript({ lines }: { lines: DisplayLine[] }) {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const viewRef = useRef<HTMLDivElement | null>(null);
  const activeRef = useRef<HTMLDivElement | null>(null);

  const recenter = () => {
    const track = trackRef.current;
    const view = viewRef.current;
    const active = activeRef.current;
    if (!track || !view) return;
    if (!active) {
      track.style.transform = "translateY(0px)";
      return;
    }
    // Place the active line at ~34% from the top of the viewport.
    const target = view.clientHeight * 0.34;
    const y = active.offsetTop + active.offsetHeight / 2;
    track.style.transform = `translateY(${Math.round(target - y)}px)`;
  };

  useLayoutEffect(recenter, [lines]);
  useEffect(() => {
    const onResize = () => recenter();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (lines.length === 0) {
    return (
      <div className="lyrics">
        <div className="lyrics-empty">
          <div className="big">Bản phiên âm sẽ hiện ở đây</div>
          <div>Nhấn “Dùng micro của bạn” hoặc xem minh hoạ trực tiếp</div>
        </div>
      </div>
    );
  }

  return (
    <div className="lyrics" ref={viewRef}>
      <div className="lyrics-track" ref={trackRef}>
        {lines.map((l) => {
          const isActive = l.kind === "active" || l.kind === "partial";
          return (
            <div
              key={l.id}
              ref={isActive ? activeRef : undefined}
              className={`lyric ${l.kind === "past" ? "past" : ""} ${
                l.kind === "active" ? "active" : ""
              } ${l.kind === "partial" ? "partial active" : ""}`}
            >
              <span className="who">{l.who}</span>
              {l.text}
            </div>
          );
        })}
      </div>
    </div>
  );
}
